module.exports = __webpack_public_path__ + "img/xiaosanjia2.dd38df27.png";